import SHDButton from '@ui/Button/SHDButton';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDText from '@ui/Text/SHDText';
import { Box } from 'grommet';
import { ScorePairingFlowSteps, StepperProps } from '../scoreSettings.d';

const Stepper: React.FC<StepperProps> = ({
  onNext,
  title,
  children,
  step,
  overTitle,
  loading,
}) => {
  const getButtonLabel = () => {
    let label = 'Next';
    if (step === ScorePairingFlowSteps.STEP_6) {
      label = 'Done';
    }
    if (step === ScorePairingFlowSteps.USE_EXISTING_TEAM_STEP_3) {
      label = 'Confirm';
    }
    return label;
  };
  return (
    <>
      <SHDModalContainer>
        <Box gap="xxxsmall">
          <SHDText style="footnote-bold" color="black-alpha-50">
            {overTitle}
          </SHDText>
          <SHDHeading level={3} formatCasing={false}>
            {title}
          </SHDHeading>
        </Box>
        <Box gap="small" margin={{ top: 'xxlarge' }}>
          {children}
        </Box>
      </SHDModalContainer>

      <SHDFooter>
        <SHDModalContainer>
          <SHDButton
            primary
            label={getButtonLabel()}
            onClick={onNext}
            disabled={loading}
          />
        </SHDModalContainer>
      </SHDFooter>
    </>
  );
};

export default Stepper;
